import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ENUMS from '../../../enums/index';
import * as cafeEventsActions from '../../../redux/cafeEvents/actions';
import Spin from '../../../components/loading';
import CafeEventDetails from '../modals/cafeEventDetails';
import ShowForPermission from '../../../components/ShowForPermission';
import { enumHelper, domManipulator } from '../../../utils';

class RequestedCafeEventsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      requestedCafeEventOpen: false,
      selectedRequestedCafeEventId: null,
      status: '',
      isActive: false,
    };
  }

  displayRequestedCafeEventModal = id => {
    let { requestedCafeEventsList } = this.props;
    let selectedRequestedCafeEventId = requestedCafeEventsList.filter(request => request.id == id)[0].id;
    this.setState({ requestedCafeEventOpen: true, selectedRequestedCafeEventId });
  };

  closeRequestedCafeEventModal = () => {
    const query = this.props.buildSearchQuery(this.props.pageNumber, this.props.pageSize);

    this.props.fetchAllRequestedCafeEvents(query).then(() => {
      const { requestedCafeEventsError, requestedCafeEventsFailed, requestedCafeEventsMessage } = this.props;
      if (
        requestedCafeEventsError == false &&
        requestedCafeEventsMessage == null &&
        requestedCafeEventsFailed == false
      ) {
        this.setState(() => ({
          requestedCafeEventOpen: false,
        }));
      } else {
        domManipulator.scrollToTop();
      }
    });
  };

  renderStatusColors = status => {
    const { CONFIRMED, DISABLED, REJECTED, REQUESTED } = ENUMS.EVENT_STATUS.values;
    switch (status) {
      case CONFIRMED:
        return 'text-success';
      case DISABLED:
        return 'text-muted';
      case REJECTED:
        return 'text-danger';
      case REQUESTED:
        return 'text-info';
      default:
        return 'text-dark';
    }
  };

  render() {
    let {
      requestedCafeEventsList = [],
      pageNumber,
      pageSize,

      requestedCafeEventsLoading,
      requestedCafeEventsMessage,
      requestedCafeEventsError,
      requestedCafeEventsFailed,
    } = this.props;
    return (
      <>
        <Spin spinning={requestedCafeEventsLoading}>
          {requestedCafeEventsError && (
            <div className="alert alert-danger">{locales('messages.server.error')}</div>
          )}
          {requestedCafeEventsFailed && (
            <div className="alert alert-danger">{requestedCafeEventsMessage}</div>
          )}
          <table className="table table-hover table-light table-striped">
            <thead>
            <tr>
              <th className="text-center">{locales('tables.row')}</th>
              <th className="text-center">{locales('fields.cafe.name')}</th>
              <th className="text-center">{locales('tables.title')}</th>
              <th className="text-center ">{locales('labels.from.date')}</th>
              <th className="text-center">{locales('labels.to.date')}</th>
              <th className="text-center">{locales('fields.weed.days')}</th>
              <th className="text-center">{locales('tables.status')}</th>
              <th className="text-center"></th>
            </tr>
            </thead>
            <tbody>
            {requestedCafeEventsList.length ? (
              requestedCafeEventsList.map((cafeEvent, index) => (
                <tr key={cafeEvent.id}>
                  <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                  <td className="text-center">{cafeEvent.cafeName}</td>
                  <td className="text-center">{cafeEvent.name}</td>
                  <td className="text-center">{cafeEvent.fromDate}</td>
                  <td className="text-center">{cafeEvent.toDate}</td>
                  <td className={`text-center`}>{cafeEvent.weekdays}</td>
                  <td className={`text-center ${this.renderStatusColors(cafeEvent.status)}`}>
                    {enumHelper.convertEnumValueToTitle(ENUMS.EVENT_STATUS.list, cafeEvent.status)}
                  </td>
                  <td title={locales('titles.eventDetails')} className="pointer text-center">
                    <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_CAFE_EVENT_DETAILS}>
                      <i
                        onClick={() => this.displayRequestedCafeEventModal(cafeEvent.id)}
                        className="far fa-info-circle"
                      />
                    </ShowForPermission>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="col-12 text-center">
                <td className="alert alert-info" colSpan={12}>
                  {locales('alerts.noRecord')}
                </td>
              </tr>
            )}
            </tbody>
          </table>
          {this.state.requestedCafeEventOpen && (
            <CafeEventDetails
              isFromRseeRequesteds={true}
              isOpen={this.state.requestedCafeEventOpen}
              eventId={this.state.selectedRequestedCafeEventId}
              closeModal={this.closeRequestedCafeEventModal}
            />
          )}
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    requestedCafeEventsList: state.cafeEventsReducer.requestedCafeEventsList,
    requestedCafeEvents: state.cafeEventsReducer.requestedCafeEvents,
    requestedCafeEventsFailed: state.cafeEventsReducer.requestedCafeEventsFailed,
    requestedCafeEventsError: state.cafeEventsReducer.requestedCafeEventsError,
    requestedCafeEventsMessage: state.cafeEventsReducer.requestedCafeEventsMessage,
    requestedCafeEventsLoading: state.cafeEventsReducer.requestedCafeEventsLoading,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllRequestedCafeEvents: query => dispatch(cafeEventsActions.fetchAllRequestedCafeEvents(query)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(RequestedCafeEventsTable),
);
